module.exports = __webpack_public_path__ + "static/pivonuv-beh-2023-cb716aeda291b8627f86747edbb02515.jpg";